import * as tslib_1 from "tslib";
import { TipoMaterialService } from "./../../../services/tipo-material.service";
import { OnInit, AfterContentInit } from "@angular/core";
import { FormGroup, Validators, FormBuilder, } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MaterialService } from "src/app/pages/cadastros/material/material.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { APP_SETTINGS, SCAMP_API } from "src/environments/environment";
//material
export class MaterialComponent {
    constructor(materialService, toastr, modalService, usuarioService, formBuilder, tipoMaterialService) {
        this.materialService = materialService;
        this.toastr = toastr;
        this.modalService = modalService;
        this.usuarioService = usuarioService;
        this.formBuilder = formBuilder;
        this.tipoMaterialService = tipoMaterialService;
        this.cadastrados = [];
        this.tiposMateriais = [];
        this.form = null;
        this.isEditing = false;
        this.isProcessing = false;
        this.isFiltered = false;
        this.voids = [];
        this.maxRowsVoids = 7;
        this.excelFileName = "";
        this.hrefExcelFile = "";
        this.ultimasEntradas = [];
        this.materialSelected = {};
        this.titleUltimasEntradas = `Exibir ${APP_SETTINGS.numeroUltimasEntradasAExibir} últimas entradas`;
    }
    ngAfterContentInit() {
        this.autorizacoes =
            this.usuarioService.getAutorizacoesJanelaPorRota("material");
    }
    ngOnInit() {
        this.getMateriais(); // carrega lista de já cadastrados
        this.getTiposMateriais();
        this.resetForm(); // instancia o formulário utilizado (formGroup)
    }
    getMateriais() {
        this.isProcessing = true;
        this.materialService.getMateriais().subscribe((response) => {
            this.cadastrados = response;
            this.setVoids();
            this.isProcessing = false;
        });
    }
    getTiposMateriais() {
        this.tipoMaterialService.getAll().subscribe((response) => {
            this.tiposMateriais = response;
        });
    }
    resetForm() {
        this.form = this.formBuilder.group({
            id: [0],
            codigo: [null, [Validators.required]],
            ncm: [null],
            descricao: [null, [Validators.required, Validators.maxLength(200)]],
            valor: [0],
            unidade: [null, [Validators.required]],
            tipoMaterialId: [""],
            precoMedio: [0],
            saldo: [0],
            atualizaMaterialValor: APP_SETTINGS.AtualizaMaterialValor,
        });
    }
    reset() {
        this.isEditing = false;
        this.isProcessing = false;
        this.resetForm();
        this.resetExcel();
    }
    resetExcel() {
        this.excelFileName = "";
        this.hrefExcelFile = "";
    }
    getById(id) {
        this.reset();
        this.isProcessing = true;
        this.materialService.read(id).subscribe((response) => {
            this.form.patchValue({
                id: response.id,
                codigo: response.codigo,
                descricao: response.descricao,
                valor: response.valor ? response.valor : 0,
                unidade: response.unidade,
                precoMedio: response.precoMedio,
                saldo: response.saldo ? response.saldo : 0,
                ncm: response.ncm ? response.ncm : null,
                tipoMaterialId: response.tipoMaterialId == null ? "" : response.tipoMaterialId,
            });
            this.isEditing = true;
            this.isProcessing = false;
        }, (error) => {
            this.showError(error);
        });
    }
    ValidUniqueFields() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { codigo, ncm, descricao, id } = this.form.value;
            let [isUniqueCodigo, isUniqueNCM, isUniqueDescricao] = yield Promise.all([
                this.materialService.isUniqueCodigoMaterial(codigo, id).toPromise(),
                this.materialService.isUniqueNCMMaterial(ncm, id).toPromise(),
                this.materialService.isUniqueDescricaoMaterial(descricao, id).toPromise(),
            ]);
            if (isUniqueCodigo == false) {
                this.form.get("codigo").setErrors({ isNotUniqueCodigo: true });
            }
            if (isUniqueNCM == false) {
                this.form.get("ncm").setErrors({ isNotUniqueNCM: true });
            }
            else {
                if (ncm && ncm.length > 0 && ncm.length !== 8) {
                    this.form.get("ncm").setErrors({ isSizeErrorNCM: true });
                    isUniqueNCM = false;
                }
            }
            if (isUniqueDescricao == false) {
                this.form.get("descricao").setErrors({ isNotUniqueDescricao: true });
            }
            return isUniqueCodigo && isUniqueNCM && isUniqueDescricao;
        });
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const valid_uniqueFields = yield this.ValidUniqueFields();
            if (valid_uniqueFields) {
                this.materialService.create(this.form.value).subscribe((response) => {
                    if (response.data) {
                        this.toastr.success(response.message);
                        this.reset();
                        this.getMateriais();
                    }
                    else {
                        this.update(this.form.value);
                    }
                }, (error) => {
                    this.showError(error);
                });
            }
        });
    }
    update(material) {
        this.materialService.create(material).subscribe((response) => {
            this.toastr.success(response.message);
            this.reset();
            this.getMateriais();
        }, (error) => {
            this.showError(error);
        }, () => (this.isProcessing = false));
    }
    setVoids() {
        this.voids = [];
        if (this.cadastrados.length < this.maxRowsVoids) {
            for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) {
                this.voids.push("");
            }
        }
    }
    showModalSm(modal) {
        this.modalService.open(modal, {
            windowClass: "smModal",
            backdrop: "static",
        });
    }
    delete(id, c) {
        this.isProcessing = true;
        c("Close click");
        this.materialService.delete(id).subscribe((response) => {
            if (response.success == true) {
                this.toastr.success(response.message);
            }
            else {
                this.toastr.warning(response.message);
            }
            this.reset();
            this.getMateriais();
        }, (error) => {
            this.showError(error);
        });
    }
    showError(error) {
        if (error.error.errors) {
            this.toastr.error(error.error.errors[0].message);
        }
        else {
            this.toastr.error("Ocorreu um erro no servidor");
        }
        this.isProcessing = false;
    }
    clearValor() {
        this.form.get("valor").setValue(0);
    }
    blurValor() {
        if (Number(this.form.get("valor").value) == 0) {
            this.clearValor();
        }
    }
    search(parametro) {
        if (parametro === "") {
            return;
        }
        this.resetExcel();
        this.isProcessing = true;
        this.materialService.search(parametro).subscribe((response) => {
            this.cadastrados = response;
            this.setVoids();
            this.isFiltered = true;
            this.isProcessing = false;
        });
    }
    clearSearch() {
        document.getElementById("parametro").value = "";
        this.getMateriais();
        this.resetExcel();
        this.isFiltered = false;
    }
    exportarToExcel(parametro) {
        this.isProcessing = true;
        this.materialService.exportarToExcel(parametro).subscribe((response) => {
            if (response.success === true) {
                if (response.nenhumResultado === false) {
                    this.excelFileName = response.fileName;
                    this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`;
                }
                else {
                    this.toastr.warning(response.msgErro);
                }
            }
            else {
                this.toastr.error(response.msgErro);
            }
            this.isProcessing = false;
        }, (err) => {
            this.toastr.error("Ocorreu um erro ao tentar exportar Excel", "Erro de Conexão");
            this.isProcessing = false;
        }, () => (this.isProcessing = false));
    }
    getNextCodigo() {
        this.materialService.getNextId().subscribe((response) => {
            this.form.get("codigo").setValue(response.result);
        });
    }
    getUltimasEntradasMaterias(materialId, modal) {
        this.materialSelected = this.cadastrados.find((x) => x.id == materialId);
        this.materialService
            .getUltimasEntradasMaterias(materialId)
            .subscribe((response) => {
            this.ultimasEntradas = response;
            this.modalService.open(modal, {
                windowClass: "lgModal",
                backdrop: "static",
            });
        });
    }
}
